  <!-- Page Header -->
  <header class="masthead" style="background-image: url('/Java/image/wale.jpg')">
    <div class="overlay"></div>
    <div class="container">
      <div class="row">
        <div class="col-lg-8 col-md-10 mx-auto">
          <div class="site-heading">
            <h2>코 딩 문 제</h2>
            <br>
            <span class="subheading">Online Judge 문 제 풀 이</span>
          </div>
        </div>
      </div>
    </div>
  </header>

  <!-- Main Content -->
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-md-10 mx-auto" style="text-align: center;">
      	<hr>
      	<br><a href="/board/baekjoon/1">Baekjoon Online Judge</a><br>&nbsp;
      	
        <!-- Pager -->
        <hr>
        <br><a href="/board/programmers/1">Programmers Online Judge</a><br>&nbsp;
        <hr>
      </div>
    </div>
  </div>
